<template>
  <span>
    <span v-if="isEdditing" v-on-clickaway="cancel">
      <form class="form-inline" @submit.prevent="save">
        <div class="input-group">
          <input type="text" ref="input" class="form-control" v-model="newValue" style="width: 130px;">
          <span class="input-group-btn">
            <button type="submit" class="btn btn-success btn-noborder">
              <i class="fa fa-spinner fa-spin" v-if="loading"></i>
              <i class="fa fa-check" v-else></i>
            </button>
          </span>
        </div>
      </form>
    </span>

    <span @click="edit" v-else>
      <span class="editable text-primary" v-if="currentValue">{{currentValue}}</span>
      <span class="editable text-danger" v-else><i>n.n.b.</i></span>
    </span>

    <text-alert :alert.sync="alert"></text-alert>
  </span>
</template>

<script>
import http from '../utils/http'
import { mixin as clickaway } from 'vue-clickaway'

export default {
  mixins: [clickaway],
  props: ['field', 'value', 'productId'],
  data () {
    return {
      isEdditing: false,
      currentValue: this.value,
      newValue: this.value,
      loading: false,
      alert: false
    }
  },
  created () {
    this.$root.$on(`product-${this.field}-updated`, this.onUpdate)
  },
  destroy () {
    this.$root.$off(`product-${this.field}-updated`, this.onUpdate)
  },
  methods: {
    edit () {
      this.newValue = this.currentValue

      this.isEdditing = true
      this.alert = false

      this.$nextTick(() => {
        const el = this.$refs.input
        el.focus()
      })
    },
    cancel () {
      this.isEdditing = false
      this.alert = false
    },
    save () {
      this.loading = true

      const data = {
        [this.field]: this.newValue
      }

      return http.patch(`/products/${this.productId}`, data)
        .then(() => {
          this.currentValue = this.newValue

          this.isEdditing = false
          this.loading = false
          this.alert = { variant: 'success', message: 'Opgeslagen' }

          this.$root.$emit(`product-${this.field}-updated`, {
            product_id: this.productId,
            value: this.newValue
          })
        })
        .catch(() => {
          this.loading = false
          this.alert = { variant: 'danger', message: 'Er is iets fout gegaan' }
        })
    },
    onUpdate (e) {
      if (this.productId === e.product_id) {
        this.currentValue = e.value
        this.newValue = e.value
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// FieldEditable.vue?d3338244